import styled from 'styled-components';
import { MEDIA_QUERY } from '@optimus-web/breakpoints';
import { getSpacingToken, getToken } from '@optimus-web/common';

export const NAVBAR_MIN_HEIGHT = 60;
export const NAVBAR_MIN_HEIGHT_DESKTOP = 80;

const Navbar = styled.nav`
    background-color: ${getToken('backgroundStaticRaised')};
    border-bottom: 1px solid ${getToken('borderStaticSecondary')};
    display: flex;
    justify-content: center;
    flex-direction: column;
    box-sizing: border-box;
    padding: ${getSpacingToken('100')}px 0;
    min-height: ${NAVBAR_MIN_HEIGHT}px;

    ${MEDIA_QUERY.tabletUp} {
        padding: 0 ${getSpacingToken('100')}px;
        height: ${NAVBAR_MIN_HEIGHT_DESKTOP}px;
    }
`;

export default Navbar;
